<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <form data-vv-scope="Add_Lead">
    <vs-row>      
      <vs-col
      v-if="leadFullDetails.root_user==0"
        vs-type="flex"
        vs-justify="left"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12"
        vs-w="12"
        class="flex-wrap p-2"
        v-for="field in staticFields"
        :key="field.id"
      >
        <label class="vs-input--label w-full"
          >{{ field.field_label
          }}<span v-if="field.enabled_parent" class="required"></span
        ></label>
        <vs-input
          class="w-full"
          v-if="field.field_name != 'platform_customer_countries_id'"
          v-validate="field.enabled_parent == true ? 'required' : ''"
          v-model="leadform[field.field_name]"
          :name="field.field_label"
          style="width: 100%"
          
        />
        <div v-else class="w-full">
        <v-select
          v-model="leadform[field.field_name]"
          v-validate="field.enabled_parent == true ? 'required' : ''"
          :reduce="(option) => option.id"
          :name="field.field_label"
          :options="countryList"
          style="width: 100%"
          label="country_name"
        />
        </div>
        <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px;" v-if="field.field_label=='Phone'">
                <span style="font-size: 14px; margin-right: 2px;" class="material-icons-outlined">info</span>Country code is mandatory.
             </div>

        <div
          v-if="errors.has(`Add_Lead.${field.field_label}`)"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first(`Add_Lead.${field.field_label}`) }}
        </div>
      </vs-col>
        <vs-col
        v-if="leadFullDetails.root_user > 0"
        vs-type="flex"
        vs-justify="left"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12"
        vs-w="12"
        class="flex-wrap p-2"
        v-for="childfield in staticChildFields"
            :key="childfield.id"
      >
        <label class="vs-input--label w-full"
              >{{ childfield.field_label
              }}<span v-if="childfield.enabled_child" class="required"></span
            ></label>
            <vs-input
              v-if="childfield.field_name != 'platform_customer_countries_id'"
              v-model="leadform[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />

            <v-select
              v-else
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              v-model="leadform[childfield.field_name]"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :placeholder="childfield.field_label"
              :reduce="(option) => option.id"
              label="country_name"
              :options="countryList"
              style="width: 100%"
            />
            <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px;" v-if="childfield.field_label=='Phone'">
                <span style="font-size: 14px; margin-right: 2px;" class="material-icons-outlined">info</span>Country code is mandatory.
             </div>

            <span
              v-show="errors.has(`Add_Lead.${childfield.field_label}`)"
              class="text-danger"
              >{{ errors.first(`Add_Lead.${childfield.field_label}`) }}</span
            >
      
      </vs-col>
      <!-- For Dynamic Field required Labels-->
      <!-- <pre>{{custom_fields}}</pre> -->
      <dynamic-component
        ref="children"
        :custom_fields_required="custom_fields"
        validatorScope="Add_Lead"
        v-model="dynamicFormObject"
      ></dynamic-component>
    </vs-row>
    <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
      <vs-button type="filled" @click.prevent="update_leads" class="mr-2"
        >Update</vs-button
      >
      <vs-button type="border" color="danger" @click="editCloseBtn" class=""
        >Cancel</vs-button
      >
    </vs-row>
    <!-- {{dynamicFormObject}} -->
  </form>
</template>

<script>
// Store Module
import { GetCountryList } from '@/api/common'
import { leadDetailsApi } from '@/api/leaddetails'
import { update_lead_list } from '@/api/leads'
import { fetchCustomFields, fetchCustomStaticFields } from '@/api/customfield'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import DynamicComponent from '@/components/common/DynamicComponent'
import { getActivityList } from '@/api/activityLog'

export default {
  components: {
    vSelect,
    flatPickr,
    DynamicComponent
  },
  data () {
    return {
      countryList: [],
      leadform: {},
      custom_fields: [],
      form: {},
      dynamicFormObject: {},
      leadid: '',
      leadFullDetails: '',
      staticFields:[],
      staticChildFields:[]
    }
  },
  mounted () {
    this.fetchLeadDetails()
    this.fetchCountry()
    this.fetch_field_list()
    // this.fetchCustomField()
  },
  methods: {
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(1, customerId)
        //

        this.staticFields = data.data.module_fields
        this.staticChildFields = data.data.module_child_fields

        //
      } catch (e) {
        console.error(e)
      } 
    },
    editCloseBtn () {
      if (this.$route.name === 'leadDetails') {
        this.$emit('closeEditForm', true)
      } else {
        this.$router.push({ name:'Leads' })
      }
      
      
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {
        console.error(e)
      }
    },
    async fetchLeadDetails () {
      this.$vs.loading()

      try {
        const { data } = await leadDetailsApi(this.$route.params.leadId, this.$store.getters.customerId)
        // const status = data

        if (data.data.leads_details.length === 0) {
          // this.$router.push({ name: 'Leads' })
          //if no data found redirect to leads page
        }
        // const status = data.data.leads_details.status

        this.leadFullDetails = data.data.leads_details
        this.fetchCustomField()

        this.leadid = this.leadFullDetails.id

        this.leadform = {
          lead_first_name: this.leadFullDetails.lead_first_name,
          lead_middle_name: this.leadFullDetails.lead_middle_name,
          lead_last_name: this.leadFullDetails.lead_last_name,
          lead_address1: this.leadFullDetails.lead_address1,
          lead_address2: this.leadFullDetails.lead_address2,
          email: this.leadFullDetails.email,
          phone: this.leadFullDetails.phone,
          platform_customer_countries_id:
            this.leadFullDetails.platform_customer_countries_id,
          lead_state: this.leadFullDetails.lead_state,
          lead_zip: this.leadFullDetails.lead_zip,
          lead_city: this.leadFullDetails.lead_city
        }

        // this.leadstatus = status
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    //fetch custom fields

    async fetchCustomField () {
      //   this.$vs.loading()

      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomFields('Leads', customerId)
        // const { data } = await fetchcustomfields('Leads')
        //
        this.custom_fields = data.data.custom_fields

        //only to fetch custom field required
        // this.custom_fields_required = this.custom_fields.filter(function (el) {
        //   return el.is_required === true
        // })

        //to assigning entity model [App/Leads,App/CLients]
        // this.entityModel = data.data.entitymodels
        //

        //for assigning customdynamic fields in form object like to array and normal.
        for (let i = 0; i < this.custom_fields.length; i++) {
          if (
            this.custom_fields[i].inputtype === 'checkbox' ||
            this.custom_fields[i].inputtype === 'multiselect'
          ) {
            // this.form[this.custom_fields_required[i].field] = []
            this.$set(
              this.dynamicFormObject,
              this.custom_fields[i].field,
              this.leadFullDetails[this.custom_fields[i].field]
            )
            //Vue.set(object, key, value) to make it reactive for dynamics form fields
          } else {
            this.dynamicFormObject[this.custom_fields[i].field] =
              this.leadFullDetails[this.custom_fields[i].field]
          }
        }
      } catch (e) {
        // this.$vs.loading.close()
      }
    },
    //fetch custom fields
    update_leads () {
      if (isNaN(this.leadform.phone)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number should be digit only',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return 
      } else if (this.leadform.phone.length !== 10 && this.leadform.platform_customer_countries_id === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number should be 10 digits',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return 
      } else if (![9, 8, 7, 6].includes(Number(String(this.leadform.phone).charAt(0))) && this.leadform.platform_customer_countries_id === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'Phone number is incorrect',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return 
      }
      const validateParent = this.$validator.validateAll('Add_Lead')
      const childDynamicComponent =
        this.$refs.children.$validator.validateAll('Add_Lead')
      const validateAll = Promise.all([validateParent, childDynamicComponent])

      validateAll.then((valid) => {        
        if (!valid.includes(false)) {
          const totalform = Object.assign(
            this.leadform,
            this.dynamicFormObject
          )

          this.update_lead_details(totalform)
        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'All validation is required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      })
    },
    async update_lead_details (data1) {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        leads_id: [this.leadid],
        update_field: data1
      }

      try {
        await update_lead_list(payload)

        await this.getLastActivity()

        this.$emit('editData', data1)

        this.$vs.notify({
          title: 'Success',
          text: 'Lead updated Successfully.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        console.error(e)
      }
    },
    async getLastActivity () {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        entity_id: this.$route.params.leadId,
        platform_module_id: 1
      }

      try {
        const response = await getActivityList(payload)
        this.$emit('activityAdded', response.data.data.activity[0])
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style scoped>
li {
  list-style: none;
}
#selectdynamic {
  width: 100%;
  height: 38px;
  border-radius: 4px;
}
#dynamicradio {
  margin-right: 10px;
}

.required:after {
  content: " *";
  color: red;
}
.con-select {
  width: 100%;
}
[dir] .flatpickr-input[readonly] {
  width: 100%;
}
</style>